/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Empty_TitleInputs */



/**
* | output |
* | --- |
* | "No 1:1s yet" |
*
* @param {Team_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_empty_title = /** @type {((inputs?: Team_Empty_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Empty_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog geen 1:1's")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore de one-to-one")
	return /** @type {LocalizedString} */ ("No 1:1s yet")
});